import { FiltersByFilterSections } from '../../constants/filter/filters_by_filter_sections';

function getFiltersByFilterSection(section) {
    return FiltersByFilterSections[section];
}

export { getFiltersByFilterSection };